module.exports = __webpack_public_path__ + "img/market1.393802ab.png";